import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import VerifyEmailOtp from 'views/pages/authentication/authentication3/VerifyEmailOtp';
import VendorInformation from 'views/pages/authentication/authentication3/VendorInformation';
import ForgotPasswordPage from 'views/pages/authentication/authentication3/ForgotPasswordPage';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const RegisterEmail = Loadable(lazy(() => import('views/pages/authentication/authentication3/RegisterEmail')));
const VendorPendingApproval = Loadable(lazy(() => import('views/vendor/VendorPendingApproval')));

const ForceChangePasswordPage = Loadable(lazy(() => import('views/pages/authentication/authentication3/ForceChangePassword')));

// ==============================|| MAIN ROUTING ||============================== //
const prefix = '';
const AuthRoutes = [
    {
        path: 'login',
        element: <AuthLogin3 />,
        prefix
    },
    {
        path: 'register', //'pages/register/register3',
        element: <RegisterEmail />,
        prefix
    },
    {
        path: 'verify-email-otp',
        element: <VerifyEmailOtp />,
        prefix
    },

    {
        path: 'vendor-information',
        element: <VendorInformation />,
        prefix
    },
    {
        path: 'vendor-pending-approval',
        element: <VendorPendingApproval />,
        prefix
    },
    {
        path: 'forgot-password',
        element: <ForgotPasswordPage />,
        prefix
    },
    {
        path: 'change-password',
        element: <ForceChangePasswordPage />,
        prefix
    }
];

export default AuthRoutes;
